// import React, { useEffect, useState } from "react";
// import { getOrders } from "../api/api";
// import "../styles/RecentOrders.css";

// const RecentOrders = () => {
//   const [orders, setOrders] = useState([]);

//   useEffect(() => {
//     fetchRecentOrders();
//   }, []);

//   const fetchRecentOrders = async () => {
//     try {
//       const response = await getOrders(); // Admin view (no user_id passed)
//       if (Array.isArray(response.data)) {
//         // Reverse the array to show the newest orders first
//         setOrders(response.data.reverse());
//       } else {
//         console.error("Unexpected orders format:", response.data);
//         setOrders([]);
//       }
//     } catch (error) {
//       console.error("Error fetching recent orders:", error);
//     }
//   };

//   // Function to format date and time in 24-hour format

//   const formatDateTime = (dateTime) => {
//     const date = new Date(dateTime);
//     return date.toLocaleString("en-GB", {
//       day: "2-digit",
//       month: "2-digit",
//       year: "numeric",
//       hour: "2-digit",
//       minute: "2-digit",
//       second: "2-digit",
//       hour12: false, // 24-hour format
//     });
//   };
//   return (
//     <div className="recent-orders">
//       <h3>Recent Orders</h3>
//       <div className="table-container">
//         <table className="orders-table">
//           <thead>
//             <tr>
//               <th>Order ID</th>
//               <th>Customer Name</th>
//               <th>Total Amount</th>
//               <th>Status</th>
//               <th>Order Date & Time</th>
//             </tr>
//           </thead>
//           <tbody>
//             {orders.length > 0 ? (
//               orders.map((order) => (
//                 <tr key={order.id}>
//                   <td>{order.id}</td>
//                   <td>{order.customer_name || "Unknown"}</td>
//                   <td>
//                     {/* Use ₹ symbol instead of $ */}
//                     ₹{parseFloat(order.total_amount).toFixed(2)}
//                   </td>
//                   <td>
//                     <span className={`status ${order.status.toLowerCase()}`}>
//                       {order.status}
//                     </span>
//                   </td>
//                   <td>
//                     {order.created_at ? formatDateTime(order.created_at) : "N/A"}
//                   </td>

//                 </tr>
//               ))
//             ) : (
//               <tr>
//                 <td colSpan="5" style={{ textAlign: "center", padding: "10px" }}>
//                   No recent orders found.
//                 </td>
//               </tr>
//             )}
//           </tbody>
//         </table>
//       </div>
//     </div>
//   );
// };

// export default RecentOrders;







import React, { useEffect, useState } from "react";
import { getOrders } from "../api/api";
import "../styles/RecentOrders.css";

const RecentOrders = () => {
  const [orders, setOrders] = useState([]);

  useEffect(() => {
    fetchRecentOrders();
  }, []);

  const fetchRecentOrders = async () => {
    try {
      const response = await getOrders(); // Admin view (no user_id passed)
      if (Array.isArray(response.data)) {
        setOrders(response.data.reverse());
      } else {
        console.error("Unexpected orders format:", response.data);
        setOrders([]);
      }
    } catch (error) {
      console.error("Error fetching recent orders:", error);
    }
  };

  // Pre-create a formatter for en-GB in IST, 24-hour
  const dateTimeFormatter = new Intl.DateTimeFormat("en-GB", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: false,
    timeZone: "Asia/Kolkata",
  });

  // Parse “YYYY-MM-DD HH:mm:ss” as UTC then format in IST
  const formatDateTime = (dateTime) => {
    if (!dateTime) return "N/A";
    const [datePart, timePart] = dateTime.split(" ");
    if (!timePart) return dateTime;

    const [year, month, day] = datePart.split("-").map(Number);
    const [hour, minute, second] = timePart.split(":").map(Number);
    // Build a UTC date so the formatter will convert to IST correctly
    const utcDate = new Date(Date.UTC(year, month - 1, day, hour, minute, second));
    return dateTimeFormatter.format(utcDate);
  };

  return (
    <div className="recent-orders">
      <h3>Recent Orders</h3>
      <div className="table-container">
        <table className="orders-table">
          <thead>
            <tr>
              <th>Order ID</th>
              <th>Customer Name</th>
              <th>Total Amount</th>
              <th>Status</th>
              <th>Order Date &amp; Time (IST)</th>
            </tr>
          </thead>
          <tbody>
            {orders.length > 0 ? (
              orders.map((order) => (
                <tr key={order.id}>
                  <td>{order.id}</td>
                  <td>{order.customer_name || "Unknown"}</td>
                  <td>
                    ₹{parseFloat(order.total_amount).toFixed(2)}
                  </td>
                  <td>
                    <span className={`status ${order.status.toLowerCase()}`}>
                      {order.status}
                    </span>
                  </td>
                  <td>
                    {formatDateTime(order.created_at)}
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="5" style={{ textAlign: "center", padding: "10px" }}>
                  No recent orders found.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default RecentOrders;
